(ns frontend.actions.declaration
  (:require
   [frontend.conn :as conn]
   [promesa.core :as p]))

(defn *->create-with-response
  [data on-success! on-error!]
  (-> (conn/sendp! :transaction-process/create-declaration
                   data
                   120000)
      (p/then (fn [{:keys [body] :as resp}]
                (if (:db/id body)
                  (on-success! resp)
                  (on-error! resp))))
      (p/catch on-error!)))
